import script from "./VirginiaView.vue?vue&type=script&setup=true&lang=js"
export * from "./VirginiaView.vue?vue&type=script&setup=true&lang=js"

import "./VirginiaView.vue?vue&type=style&index=0&id=6beb5e62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6beb5e62"]])

export default __exports__